export default {
  challenges: 'Challenges',
  home: 'Home',
  library: 'Library',
  logout: 'Log out',
  store: 'Store'
}
  